/** Keep persisted IDs stable; mode is independent of a theme's color palette. */
export const PORTAL_THEMES = [
  { id: 'light', label: 'Blue', mode: 'light', className: 'theme-light', swatch: 'linear-gradient(135deg, #edf3f8, #005595 60%, #00695c)' },
  { id: 'dark', label: 'Blue', mode: 'dark', className: 'theme-dark', swatch: 'linear-gradient(135deg, #a6d4ff, #1976d2 35%, #27272a 75%)' },
  { id: 'lavender', label: 'Lavender', mode: 'light', className: 'theme-lavender', swatch: 'linear-gradient(135deg, #eeebf7, #6440a5 55%, #1976d2)' },
  { id: 'charcoal', label: 'Lavender', mode: 'dark', className: 'theme-charcoal', swatch: 'linear-gradient(135deg, #c5b1ff, #90caf9 35%, #27272a 75%)' },
  { id: 'forest', label: 'Forest', mode: 'light', className: 'theme-forest', swatch: 'linear-gradient(135deg, #e6f1ea, #286445 55%, #00796b)' },
  { id: 'forest-dark', label: 'Forest', mode: 'dark', className: 'theme-forest-dark', swatch: 'linear-gradient(135deg, #a5d6b3, #80cbc4 35%, #252b28 75%)' },
  { id: 'bronze', label: 'Bronze', mode: 'light', className: 'theme-bronze', swatch: 'linear-gradient(135deg, #f4e8da, #8c572b 55%, #a56b36)' },
  { id: 'bronze-dark', label: 'Bronze', mode: 'dark', className: 'theme-bronze-dark', swatch: 'linear-gradient(135deg, #e4b88b, #ce9360 35%, #2c2825 75%)' },
  { id: 'rose', label: 'Rose', mode: 'light', className: 'theme-rose', swatch: 'linear-gradient(135deg, #f9e7ef, #ad3269 55%, #7b1fa2)' },
  { id: 'rose-dark', label: 'Rose', mode: 'dark', className: 'theme-rose-dark', swatch: 'linear-gradient(135deg, #f3accb, #ce93d8 35%, #2d272b 75%)' },
] as const;

export type PortalThemeId = typeof PORTAL_THEMES[number]['id'];

export function resolveTheme(id: string | null | undefined) {
  return PORTAL_THEMES.find(theme => theme.id === id) ?? PORTAL_THEMES[0];
}

/** Update both the layout and CDK overlay host without disturbing other classes. */
export function applyTheme(element: HTMLElement, id: string | null | undefined): void {
  const theme = resolveTheme(id);
  element.classList.remove(...PORTAL_THEMES.map(item => item.className));
  element.classList.add(theme.className);
  element.classList.toggle('theme-dark', theme.mode === 'dark');
  element.style.colorScheme = theme.mode;
}
